import React from "react";
import {Box, Grid2} from "@mui/material";
//import Footer from "./Footer";
import logo from '../logo-transparent.png';
import {Link} from "react-router-dom";

function SplashScreen({ background, title , children }) {

    return (
        <Box
            width="100vw"
            height="100%"
            minHeight="100vh"
            bgColor={background}
            sx={{ overflowX: "hidden" }}
        >
            <Box
                position="absolute"
                width="100%"
                minHeight="100vh"
                sx={{
                    backgroundImage: `url(${background})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    zIndex: 0,
                }}
            />
            <Box px={1} width="100%" height="100vh" mx="auto">
                <Grid2 container spacing={1} justifyContent="center" alignItems="center" height="100%">
                    <Grid2 item xs={11} sm={9} md={5} lg={4} xl={3} sx={{zIndex: 100, textAlign: 'center', background: '#fff'}}>
                        <Link to={'/'}><img src={logo} width="40%" alt={title} style={{marginBottom: '20px', maxWidth: '80vw'}}/></Link>
                        {children}
                    </Grid2>
                </Grid2>
            </Box>
            {/*<Footer light />*/}
        </Box>

    );
}

export default SplashScreen;